// Runtime APIs for fetching remote images on Cloudinary
exports.getFixedImageObject = require('../get-image-objects').getFixedImageObject;
exports.getFluidImageObject = require('../get-image-objects').getFluidImageObject;
